export default {
  steps: {
    0: {
      title: 'Sé un cliente habitual',
      description: 'Consulta tu historial de pedidos y vuelve a pedir con un solo toque.',
    },
    1: {
      title: 'Consigue recompensas',
      description: 'Sigue tus puntos y canjea recompensas guardadas desde tu billetera.',
    },
    2: {
      title: 'Pide con anticipación',
      description: 'Encuentra tu local más cercano y haz tu pedido más rápido que nunca.',
    },
  },
  buttons: {
    skip: 'Omitir',
  },
};
